// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".actions[data-v-1c574d37] {\n  padding: 10px;\n  min-width: 40px;\n  max-width: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
